import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Location } from '@core/interfaces';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';
import { sentry } from 'sentry';
import { searchManyInputStyles } from '../../base/fc-search-many-input/fc-search-many-input.component';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';

const SEARCH_QUERY = gql`
  query searchLocations($where: LocationWhereInput, $limit: Int, $offset: Int) {
    locations(
      where: $where
      orderBy: {
        column: name,
        direction: asc
      }
      limit: $limit
      offset: $offset
    ){
      items {
        id
        name
        address {
          formattedAddress,
          postalCode,
          streetName,
          city,
          number,
          complement,
          neighborhood,
          state,
          coords {
            latitude,
            longitude
          }
        }
      }
    }
  }
`;

@Component({
  selector: 'fc-locations-input',
  templateUrl: './fc-locations-input.component.html',
  styleUrls: ['./fc-locations-input.component.scss']
})
export class FcLocationsInputComponent {

  @Input() public control: FormControl;
  @Input() public showSearchIcon: boolean;
  @Input() public desiredStyle: searchManyInputStyles = searchManyInputStyles.Select;

  constructor(
    private readonly fuseTranslationLoaderService: FuseTranslationLoaderService,
    private readonly apollo: Apollo
  ) {
    this.fuseTranslationLoaderService.loadJsonTranslations({ english, portuguese, spanish });
    this.search = this.search.bind(this);
    this.displayWith = this.displayWith.bind(this);
  }

  async search(searchTerm: string, limit: number, offset: number): Promise<any[]> {
    return this.apollo
      .query({
        query: SEARCH_QUERY,
        variables: {
          where: {
            formattedAddressOrDocumentNumber_contains: searchTerm,
            archived: false
          },
          limit: limit,
          offset: offset
        },
      })
      .toPromise()
      .then((result) => {
        return result.data['locations']['items'];
      })
      .catch((err) => {
        sentry.captureException(err);
        return [];
      });
  }

  displayWith(value: Location): string {
    return value && value.address && value.address.formattedAddress;
  }
}
